import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { DividerModule } from '@openng/optimus-ui/divider';
import { Validators } from '@angular/forms';

import { fb, routeParams } from '../../../../../modules/shared/shared.global-service';
import { isInvalid } from '../../../../../modules/shared/helpers/validate';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { OrganizationSettingsDepartmentDialogStore } from './organization-settings-department-dialog.store';
import { DepartmentObject } from '@libs/types/src/mado/object-type/organization/department.object';
import { departmentMutationFrag } from './organization-settings-department-dialog.query'
import { TextInputComponent } from '../../../../kit/input/text-input/text-input.component';

@Component({
    selector: 'app-organization-settings-department-dialog',
    templateUrl: './organization-settings-department-dialog.component.html',
    providers: [OrganizationSettingsDepartmentDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        DividerModule,
        TextInputComponent,
    ]
})
export class OrganizationSettingsDepartmentDialogComponent extends BaseDialogComponent {
    protected readonly store = inject(OrganizationSettingsDepartmentDialogStore);

    protected readonly data = this.dialogConfig.data.department || null;

    protected form = fb.group({
        id: fb.control<number | null>(null),
        name: fb.control<string | null>(null, [Validators.required]),
        code: fb.control<string | null>(null, [Validators.required]),
        description: fb.control<string | null>(null),
    })

    protected readonly prefix = 'organization-settings.mado.department.';

    constructor(
    ) {
        super();

        effect(() => {
            this.patchForm(this.data);
        });
    }

    override async save() {
        if (isInvalid(this.form)) return;

        const data = {
            name: this.form.value.name!,
            code: this.form.value.code!,
            description: this.form.value.description,
        }

        if (this.form.value.id) {
            await this.store.api.updateDepartment(
                {
                    id: this.form.value.id,
                    ...data,
                },
                departmentMutationFrag,
            )

            contentGlobalSuccess.next('common.updated')
            this.dialogRef.close(true);

        } else if (routeParams.organizationId()) {
            await this.store.api.createDepartment(
                {
                    organizationId: Number(routeParams.organizationId()),
                    ...data,
                },
                departmentMutationFrag,
            )

            contentGlobalSuccess.next('common.created')
            this.dialogRef.close(true);
        }
    }

    private patchForm(item: DepartmentObject | null) {
        if (item) {
            this.form.patchValue({
                id: item.id,
                name: item.name,
                code: item.code,
                description: item.description,
            })
        }
    }
}
